export const OFFICES_ACTIONS = {
    GET_ALL_OFFICES: 'GET_ALL_OFFICES',
    GET_USER_ACTIVE_OFFICES: 'GET_USER_ACTIVE_OFFICES',
    FIND: 'FIND_OFFICES',
    DELETE: 'DELETE_OFFICES',
    SUGGESTION: 'SUGGESTION_OFFICES',
    SUGGESTION_CLEAN: 'SUGGESTION_CLEAN_OFFICES',
    CLEAN_USER_ACTIVE_OFFICES: 'CLEAN_USER_ACTIVE_OFFICES',

    CHANGE_STATUS: 'CHANGE_STATUS_OFFICES',
    SUCCESS: 'SUCCESS_OFFICES',
    ERROR: 'ERROR_OFFICES',
    RESET: 'RESET_OFFICES',
    CLEAN: 'CLEAN_OFFICES',
}